import React from "react";

import { useTranslation } from "react-i18next";

function Button ( { className } ) {

    const { t } = useTranslation();
      
    return(
        <div className={className}>
            <a href="http://user.dashboardcenter.ltd/">
                <div className="button-m flex cursor-pointer hover:scale-[1.1] transition-all">
                    <p className="text-white inter font-[700] text-[16px]">{t('home.3')}</p>
                </div>
            </a>
        </div>
    );
}

export default Button;